import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=751cf32e&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"
import style0 from "../../theme/text.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Text.vue?vue&type=style&index=1&id=751cf32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751cf32e",
  null
  
)

export default component.exports